module.exports = __webpack_public_path__ + "static/shared/img/icons/iconAllyDownload-IC-White.9750b42d5d7fe4baf2432a3dc743a1a3.svg";